<!-- APP CONTAINER -->
<div id="ContainerApp" [class]="appProperty.appStyleClass">
  @if (appProperty.loginPageNotVisible | async) {
  <nav class="navbar navbar-light navbar-suite">
    <a class="navbar-brand" href="javascript:void(0)" style="margin-left: 1rem;">
      <i id="appsIcon" aria-hidden="true" class="fa fa-th fa-lg appsIcon amSuiteDefault"
        (click)="op.toggle($event)"></i>
      <label class="amSuiteDefault" for="appsIcon">{{appProperty.appFuctionName}}</label>
      <button id="myButton" type="button" class="btn btn-primary showNotifyButton" (click)="showNotify()"
        disabled></button>
    </a>

    <div class="text-white user-section">
      @if (sessionService.getSession && userProperty.userSelectedCompany) {
      <div class="topbar-actions">
        @if (appProperty.impersonateIsActive) {
        <div class="impersonate-actions">
          @if (innerWidth >= 1000) {
          <p-button pRipple [loading]="impersonateLoader" icon="pi pi-user-minus"
            label=" {{ 'account.remove-impersonate' | translate }}" styleClass="p-button-sm topbar-impersonate-btn"
            (click)="removeImpersonate()"></p-button>
          }
          @if (innerWidth < 1000) { <p-button pRipple [loading]="impersonateLoader"
            icon="pi pi-user-minus" styleClass="p-button-sm topbar-impersonate-icon-btn"
            [pTooltip]="'account.remove-impersonate' | translate" tooltipPosition="bottom"
            (click)="removeImpersonate()">
            </p-button>
          }
        </div>
          }

          <!-- OAuth Provider Box -->
          @if (appStateHolder.oauthState.providers.length > 0) {
          <div class="oauth-providers-box">
            @for (provider of appStateHolder.oauthState.providers; track provider.provider) {
            @if (provider.provider === 'Office365' || provider.provider === 'Microsoft') {
            <div class="oauth-provider-item"
              [class.oauth-active]="getOAuthProviderStatus(provider.provider) === 'active'"
              [class.oauth-expiring]="getOAuthProviderStatus(provider.provider) === 'expiring'"
              [class.oauth-expired]="getOAuthProviderStatus(provider.provider) === 'expired'"
              [pTooltip]="provider.provider" tooltipPosition="bottom"
              (click)="showOAuthPanel($event, provider.provider)">
              <img src="assets/CustomIcons/microsoftprovider.svg" class="oauth-svg-icon-box microsoft-icon-box" />
            </div>
            }
            @if (provider.provider === 'Jira' || provider.provider === 'Atlassian') {
            <div class="oauth-provider-item"
              [class.oauth-active]="getOAuthProviderStatus(provider.provider) === 'active'"
              [class.oauth-expiring]="getOAuthProviderStatus(provider.provider) === 'expiring'"
              [class.oauth-expired]="getOAuthProviderStatus(provider.provider) === 'expired'"
              [pTooltip]="provider.provider" tooltipPosition="bottom"
              (click)="showOAuthPanel($event, provider.provider)">
              <img src="assets/CustomIcons/jiraprovider.svg" class="oauth-svg-icon-box jira-icon-box" />
            </div>
            }
            }
          </div>
          }

          <div class="topbar-icon-actions">
            <i class="pi pi-question-circle navActionIcon topbar-nav-icon"
              (click)="visibleSupportSidebar = true"></i>
            @if (alertsCount > 0) {
            <i class="pi pi-bell navActionIcon topbar-nav-icon" pBadge [value]="alertsCount" severity="info"
              (click)="visibleAlertSidebar = true"></i>
            }
            @if (alertsCount === 0) {
            <i class="pi pi-bell navActionIcon topbar-nav-icon" (click)="visibleAlertSidebar = true"></i>
            }
            @if (showAIIcon) {
            <i class="pi pi-sparkles aiIcon topbar-nav-icon" (click)="visibleCopilotSidebar = true"></i>
            }
            <i class="fa fa-user-circle-o userDefaultIcon topbar-nav-icon" aria-hidden="true"
              (click)="visibleSidebar = true"></i>
          </div>
      </div>
      }
      <div class="userInfo">
        @if (sessionService.getSession && userProperty.userSelectedCompany) {
        <div class="userDefaultInfo" (click)="visibleSidebar = true">
          <div class="username detail-user-bar">
            {{ sessionService.fullName }}
          </div>
          <div class="email">
            {{ sessionService.email }}
          </div>
          <div class="company-selected">
            {{ userProperty.userSelectedCompany.name }}
          </div>
        </div>
        }
      </div>
    </div>
  </nav>
  }

  <div>
    <!-- sidebar -->
    @if (sidebarSrv.showSidebar) {
    <div>
      <app-sidebar></app-sidebar>
    </div>
    }

    <!-- OUTLET FOR COMPONENT -->
    <div [@routeAnimations]="prepareOutlet(outlet)"
      [class]="sidebarSrv.showSidebar ? 'main-router-content' : 'no-sidebar-content'"
      [class.expanded]="sidebarSrv.isExpanded | async">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </div>

  @if (appProperty.loadingData | async) {
  <div class="spinneram">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
    Caricamento...
  </div>
  }
</div>

<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'"
  [showTransformOptions]="'translateX(100%)'" appendTo="body" key="addWidgetFromApp"></p-toast>
<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'"
  [showTransformOptions]="'translateX(100%)'" key="manageDash" appendTo="body"
  (click)="appStateHolder.clearToasts()"></p-toast>

<user-menu [visible]="visibleSidebar" (close)="visibleSidebar = false"></user-menu>

<alert [visible]="visibleAlertSidebar" (alertsCount)="updateAlertsCount($event)" (close)="visibleAlertSidebar = false">
</alert>


@if (visibleCopilotSidebar) {
<p-sidebar [(visible)]="visibleCopilotSidebar" position="right" [styleClass]="getSidebarClass()"
  (onHide)="visibleCopilotSidebar = null">
  <ng-template pTemplate="header">
    <div class="row copilotPanelHeader">
      <div class="col-1 ">
        <i class="pi pi-sparkles pr-2 sideBotIcon sideSparkleIcon"></i>
      </div>
      <div class="col-11">
        <span class="botTitle">AmSuite Assistant</span>
      </div>
    </div>
  </ng-template>
  <!-- <am-copilot [visible]="visibleCopilotSidebar" (close)="visibleCopilotSidebar = false"></am-copilot> -->
  <amsuite-assistant-bot #chatBot [bearerToken]="bearerToken" [dataOwnerId]="userProperty.userSelectedCompany?.id"
    [userModel]="sessionService.getSession" [idChat]="idChat" [userName]="sessionService.fullName" [source]="'amsuite'">
  </amsuite-assistant-bot>


</p-sidebar>
}

<support [visible]="visibleSupportSidebar" (close)="visibleSupportSidebar = false"></support>

<p-overlayPanel #op styleClass="app-menu" appendTo="body">
  <ng-template pTemplate>
    <div class="row">
      @for (app of userProperty.userSelectedCompany.apps; track $index) {
      <div class="appSelector col-sm-6 col-md-6 col-lg-6" (click)="onSelectApp(app); op.hide()">
        <div style="display: table-cell; width: 2rem;">
          <button type="button" [class]="app.cssParams.menuItemClass" style="margin-top: 2px; border-radius: 5px;">
            <i [class]="app.cssParams.menuIconClass" aria-hidden="true"></i>
          </button>
        </div>
        <div class="appNameLabelBox">
          <label class="companyTruncate appName" [pTooltip]="app.functionName">{{app.functionName}}</label>
        </div>
      </div>
      }
    </div>
  </ng-template>
</p-overlayPanel>

<p-overlayPanel #oauthPanel styleClass="oauth-status-panel" appendTo="body">
  <ng-template pTemplate>
    <div class="oauth-panel-content" *ngIf="selectedOAuthProvider">
      <!-- Header con icona e nome provider -->
      <div class="oauth-panel-header">
        @if (selectedOAuthProvider === 'Office365' || selectedOAuthProvider === 'Microsoft') {
        <img src="assets/CustomIcons/microsoftprovider.svg" class="oauth-panel-svg-icon" />
        }
        @if (selectedOAuthProvider === 'Jira' || selectedOAuthProvider === 'Atlassian') {
        <img src="assets/CustomIcons/jiraprovider.svg" class="oauth-panel-svg-icon" />
        }
        <span class="oauth-provider-name">{{ selectedOAuthProvider }}</span>
      </div>

      <!-- Status content -->
      <div class="oauth-panel-status">
        @if (getOAuthProviderStatus(selectedOAuthProvider) === 'active') {
        <div class="oauth-status-item">
          <i class="pi pi-check-circle oauth-status-icon-active"></i>
          <div class="oauth-status-info">
            <div class="oauth-status-label">{{ 'oauth.active' | translate }}</div>
            <div class="oauth-status-expire">
              {{ 'oauth.expiresOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
              translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
            </div>
          </div>
        </div>
        }

        @if (getOAuthProviderStatus(selectedOAuthProvider) === 'expiring') {
        <div class="oauth-status-item">
          <i class="pi pi-exclamation-triangle oauth-status-icon-expiring"></i>
          <div class="oauth-status-info">
            <div class="oauth-status-label">{{ 'oauth.expiring' | translate }}</div>
            <div class="oauth-status-expire">
              {{ 'oauth.expiresOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
              translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
            </div>
          </div>
        </div>
        }

        @if (getOAuthProviderStatus(selectedOAuthProvider) === 'expired') {
        <div class="oauth-status-item">
          <i class="pi pi-times-circle oauth-status-icon-expired"></i>
          <div class="oauth-status-info">
            @if (formatOAuthExpiryDate(selectedOAuthProvider)) {
            <div class="oauth-status-label">{{ 'oauth.expired' | translate }}</div>
            <div class="oauth-status-expire">
              {{ 'oauth.expiredOn' | translate }} {{ formatOAuthExpiryDate(selectedOAuthProvider) }} {{ 'oauth.at' |
              translate }} {{ formatOAuthExpiryTime(selectedOAuthProvider) }}
            </div>
            }
            @if (!formatOAuthExpiryDate(selectedOAuthProvider)) {
            <div class="oauth-status-label">{{ 'oauth.notConfigured' | translate }}</div>
            }
          </div>
        </div>
        }
      </div>

      <!-- OAuth authorization button - always visible -->
      <div class="oauth-authorize-section">
        <p-button [raised]="true" [loading]="oauthAuthorizingProvider === selectedOAuthProvider"
          label="{{ 'oauth.authorize' | translate }}" styleClass="p-button-warning"
          (click)="authorizeOAuthProvider(selectedOAuthProvider); oauthPanel.hide()">
        </p-button>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>

